// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomHeading3 = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: 'url(#clip0_943_164983)',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0.84052 2.6H2.22719V6.90667H8.30719V2.6H9.69385V13H8.30719V8.24H2.22719V13H0.84052V2.6ZM13.3264 16.128C12.8731 16.128 12.4704 16.0347 12.1184 15.848C11.7664 15.656 11.4918 15.392 11.2944 15.056C11.1024 14.7147 11.0064 14.328 11.0064 13.896H11.8544C11.8704 14.328 12.0091 14.6773 12.2704 14.944C12.5371 15.2053 12.8864 15.336 13.3184 15.336C13.7558 15.336 14.1051 15.2213 14.3664 14.992C14.6278 14.7573 14.7584 14.4427 14.7584 14.048C14.7584 13.6853 14.6331 13.3947 14.3824 13.176C14.1318 12.9573 13.7958 12.848 13.3744 12.848C13.2784 12.848 13.1771 12.8587 13.0704 12.88C12.9691 12.896 12.8811 12.9173 12.8064 12.944L12.3664 12.48L14.1904 10.472H11.1744V9.68H15.5184V10.216L13.6224 12.216C13.9904 12.2213 14.3238 12.2987 14.6224 12.448C14.9211 12.592 15.1558 12.8027 15.3264 13.08C15.5024 13.3573 15.5904 13.688 15.5904 14.072C15.5904 14.472 15.4944 14.8293 15.3024 15.144C15.1158 15.4533 14.8491 15.696 14.5024 15.872C14.1611 16.0427 13.7691 16.128 13.3264 16.128Z',
        fill: 'currentColor',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: 'clip0_943_164983',
        },
        /*#__PURE__*/ React.createElement('rect', {
          width: '16',
          height: '16',
          fill: 'white',
        }),
      ),
    ),
  );

export { IconCustomHeading3 };
